import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

import AnyDocCard20321 from '@/app/components/doc/AnyDocCard20321.vue'
import ArticleCard from '@/app/components/article/Card.vue'
import BookCard from '@/app/components/book/card/BookCard.vue'
import EpisodeCard from '@/app/components/podcast/card/EpisodeCard.vue'
import CTACard from '@/app/components/listing/CTACard.vue'
import CollectionCard from '@/app/components/collections/card/CollectionCard.vue'
import PodcastCard from '@/app/components/podcast/card/PodcastCard.vue'
import ContinueReadingCard from '@/app/components/book/card/ContinueReadingCard.vue'
import NewReleasesCard from '@/app/components/book/card/NewReleasesCard.vue'

import type { ListView } from '@/models/docs.list'
import type { ListItem, ListItemType } from '@/models/interfaces'
import { computed } from 'vue'
import type { Component } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ListCard',
  props: {
    view: {},
    doc: {}
  },
  setup(__props: any) {

const props = __props

const cardComponents: Record<ListItemType, Component> = {
  book: BookCard,
  article: ArticleCard,
  podcast_episode: EpisodeCard,
  collection: CollectionCard,
  podcast: PodcastCard,
  custom_list: CollectionCard,
}

const cardComponent = computed(() => {
  switch (props.view.customCardComponent) {
    case 'ContinueReadingCard':
      return ContinueReadingCard
    case 'NewReleasesCard':
      return NewReleasesCard
    case 'AnyDocCard':
      return AnyDocCard20321
    default:
      if (!props.view.docTypeName) {
        return AnyDocCard20321
      } else {
        return cardComponents[props.view.docTypeName]
      }
  }
})

return (_ctx: any,_cache: any) => {
  return (__props.doc.title === 'CTA')
    ? (_openBlock(), _createBlock(CTACard, {
        key: 0,
        docTypeLabel: __props.view.docTypeLabel,
        baseClass: __props.view.cssClassModifier
      }, null, 8, ["docTypeLabel", "baseClass"]))
    : (_openBlock(), _createBlock(_resolveDynamicComponent(cardComponent.value), {
        key: 1,
        class: "doc__item",
        view: __props.view.docs(),
        doc: __props.doc,
        customList: __props.view.customList
      }, null, 8, ["view", "doc", "customList"]))
}
}

})